import script from "./Issues.vue?vue&type=script&lang=ts&setup=true"
export * from "./Issues.vue?vue&type=script&lang=ts&setup=true"

import "./Issues.vue?vue&type=style&index=0&id=3ce080a2&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce080a2"]])

export default __exports__